import React, { useRef } from 'react'
import Textarea from './Textarea'

/**
 * A textarea suited for code/formula input: mono font, Tab inserts 4 spaces,
 * and pasted tabs are normalized to 4 spaces.
 */
export default function CodeTextarea ({ value, onChange, rows = 8, ...props }) {
  const ref = useRef(null)

  const handleChange = (e) => {
    const v = e.target.value
    if (v.includes('\t')) {
      onChange({ target: { value: v.replace(/\t/g, '    ') } })
    } else {
      onChange(e)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault()
      const el = ref.current
      if (!el) return
      const start = el.selectionStart
      const end = el.selectionEnd
      const before = (value ?? '').slice(0, start)
      const after = (value ?? '').slice(end)
      const newValue = before + '    ' + after
      onChange({ target: { value: newValue } })
      window.requestAnimationFrame(() => {
        el.selectionStart = el.selectionEnd = start + 4
      })
    } else if (props.onKeyDown) {
      props.onKeyDown(e)
    }
  }

  return (
    <Textarea
      ref={ref}
      rows={rows}
      fontFamily='mono'
      value={value ?? ''}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      {...props}
    />
  )
}
